import { css } from "styled-components";
// Applies the provided styles only in browsers that support the :has() selector
export function supportsHasSelector(styles, { fallbackStyles } = {}) {
    return css `
    @supports selector(:has(> *)) {
      ${styles}
    }

    ${fallbackStyles &&
        css `
      @supports not selector(:has(> *)) {
        ${fallbackStyles}
      }
    `}
  `;
}
